
/**
 * Model for Sanction Matching Logs.
 * 
 * 
 */
export class SanctionLog {
    id: number;
    jobName: string;
    dateRun: Date;
    totalEntitiesProcessesed: number;
    totalEntitiesSanctioned: number;
    totalHits: number;  
}



// WEBPACK FOOTER //
// ./src/app/shared/models/SanctionLog.model.ts